import { asTrackingPayload, asWidgetProps } from 'Src/types/widget-helpers';
import type { ComponentProps } from 'react';
import { has } from 'lodash';
import React, { useState } from 'react';
import { appQueryParameters } from '@clubmed/utils';
import { useRouter } from 'next/router';
import { ID_LAYER_HEADER__CA__ESF } from 'Components/utils/identifiers/constants';
import { LAYER_NAME_UPSELL_ESF } from 'Components/utils/layers/layers.constants';
import { t } from 'Src/i18n';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { ClosableLayer } from 'Components/widgets/layer/ClosableLayer';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { StayLayerHeader } from 'Components/widgets/stay-layer-header/StayLayerHeader';
import { EsfLayerIntroduction } from './EsfLayerIntroduction';
import { EsfWidget } from './EsfWidget';
type Props = PropsWithPageTracking<{
  forwardRef: ReactRef;
  stay: StayEntity;
}>;
export const EsfLayer = ({ forwardRef, stay, tracking }: Props) => {
  const [showEsfWidget, setShowEsfWidget] = useState(false);
  const { query } = useRouter();
  const { trackClickEvent } = useTrackEvent();

  const openEsfWidget = () => {
    trackClickEvent(
      TRACK_EVENT_NAMES.CLICK_UPSELL,
      asTrackingPayload({
        detail_click: 'add_esf_lessons',
      }),
    );
    setShowEsfWidget(true);
  };

  const closeEsfWidget = () => {
    setShowEsfWidget(false);
  };

  const { mode, id, type, result, execcode } = appQueryParameters.ignore;
  const showEsfTunnel = has(query, 'mode');
  const title = t('stays.upsells.esf.title');
  return (
    <ClosableLayer
      {...asWidgetProps<ComponentProps<typeof ClosableLayer>>({
        ariaLabel: title,
        ariaLabelledby: ID_LAYER_HEADER__CA__ESF,
        externalFocusTrapRefs: [forwardRef],
        hasAnimateEnter: true,
        header: <StayLayerHeader id={ID_LAYER_HEADER__CA__ESF} stay={stay} title={title} />,
        name: LAYER_NAME_UPSELL_ESF,
        onBack: showEsfWidget ? closeEsfWidget : undefined,
        params: [mode, id, type, result, execcode, 'id', 'stayId'],
        tracking,
      })}
    >
      <SiteContainer className="py-20" size="medium" data-testid="ESFLayer">
        {showEsfWidget || showEsfTunnel ? (
          <EsfWidget showEsfTunnel={showEsfTunnel} stay={stay} />
        ) : (
          <EsfLayerIntroduction openEsfWidget={openEsfWidget} />
        )}
      </SiteContainer>
    </ClosableLayer>
  );
};
